module.exports = __webpack_public_path__ + "img/icon_delete@2x.05ae34d1.png";